<button mat-raised-button *ngIf='showButton' (click)="onClick()">Reject</button>